import { useUpdatePermissions } from "api/permissions/usePermissions";
import GuiContext from "config/context/guiContext";
import { useCallback, useContext, useState } from "react";
import { useGetDatabaseStructureService } from "./useGetDatabaseStructureService";
import { useCompositionsContext } from "features/compositions/context/CompositionsContext";
import { toWireComposition } from "features/compositions/utils/fieldTypes";

const initialServerStatus = {
    response: null,
    loading: false,
    error: null,
}

export const useAddComposition = () => {
    const [response, setResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { getDatabaseStructure } = useGetDatabaseStructureService();
    const { updatePermissions } = useUpdatePermissions();
    const { setSelectedComposition } = useCompositionsContext();

    const {
        selected: { selectedAccount, selectedServer },
        URL
    } = useContext(GuiContext);

    const addComposition = async ({ data }) => {
        // Clear selectedComposition before starting the request
        setSelectedComposition({
            name: '',
            meta_name: '',
            permission: '',
            description: '',
            count: 0,
            scopes: [],
            selected_scope: '',
            structure: {
                indexes: [],
                fields: []
            },
            rows: []
        });

        const payload = {
            server_url: selectedServer || "",
            database: selectedAccount || "",
            private_key: data.private_key || "",
            // `decimal` je rečnik čarobnjaka; lanac zna za `int64_t`, a logički
            // tip putuje uz njega u `db.struct`. Vidi `utils/fieldTypes.js`.
            compositions: (data.compositions || []).map(toWireComposition),
        };

        setLoading(true);

        try {
            const res = await fetch(`${URL}/api/database/create`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', },
                credentials: 'include',
                body: JSON.stringify(payload),
            });

            const data = await res.json();
            setResponse(data);
            getDatabaseStructure();
            updatePermissions();
            if (!data?.status) {
                setError(data?.message);
            }
        } catch (err) {
            setError(err.message || 'An error occurred');
        } finally {
            setLoading(false);
        }
    };

    const resetServerStatus = useCallback(() => {
        setLoading(initialServerStatus.loading);
        setResponse(initialServerStatus.response);
        setError(initialServerStatus.error);
    }, [])

    return {
        response,
        loading,
        error,
        addComposition,
        resetServerStatus
    };
};